import { InputAdornment, TextField } from '@mui/material'
import { useFieldContext } from '@zealth/core/form/contexts'
import type { ZipCodeFormFieldProps } from '@zealth/core/formFields/types'
import { parseZipCode } from '@zealth/core/zipCode'
import { useMemo } from 'react'
import { NumberFormatBase } from 'react-number-format'

const ZipCodeAdornment = ({ value }: { value: string }) => {
  const location = useMemo(() => {
    if (!value) return ''

    const result = parseZipCode(value)
    if (!result) return ''

    return result.state
  }, [value])

  return <InputAdornment position="end">{location}</InputAdornment>
}

export const ZipCodeFormField = ({
  label,
  optional,
  placeholder,
  disabled,
}: ZipCodeFormFieldProps) => {
  const field = useFieldContext<string>()

  const formatZip = (value: string): string => {
    if (!value) return ''
    const digits = value.replace(/\D/g, '')
    return digits.length <= 5
      ? digits
      : `${digits.slice(0, 5)}-${digits.slice(5, 9)}`
  }

  return (
    <NumberFormatBase
      customInput={TextField}
      fullWidth
      label={label}
      required={!optional}
      placeholder={placeholder}
      disabled={disabled}
      format={formatZip}
      isAllowed={({ value }) => value.length <= 9}
      value={field.state.value}
      error={field.state.meta.errors.length > 0}
      helperText={field.state.meta.errors[0]?.message ?? ' '}
      onBlur={field.handleBlur}
      onValueChange={({ formattedValue }) => field.handleChange(formattedValue)}
      slotProps={{
        input: {
          endAdornment: <ZipCodeAdornment value={field.state.value} />,
        },
      }}
    />
  )
}
